import React, { PropsWithChildren } from "react";
import { canCreateCustomers } from "../common/helpers/municipalityRoles";
import MunicipalityRoleAuthorized from "./MunicipalityRoleAuthorized";

const CustomerCreationAuthorized = (props: PropsWithChildren<{}>) => (
    <MunicipalityRoleAuthorized
        canAccess={(user) =>
            canCreateCustomers(
                user.municipalityRole,
                user.customerCreationAllowed,
            )
        }
    >
        {props.children}
    </MunicipalityRoleAuthorized>
);

export default CustomerCreationAuthorized;
